import React from "react";
import { fetchPanelApi } from "static-content/view/api";
import { Button, TextWrapper, ButtonWrapper } from "./LegalStyles";
import { giveCookieConsent, cookieConsentGiven } from "../cookies/CookiesHelper";
import { useModal, toggleModal } from "../modal/Modal";
import { isFalseOrMissing } from "../boolean-parser";

export const AcceptCookies = (props) => {
  const panelApi = fetchPanelApi("COOKIES_PANEL");
  const { RenderModal } = useModal("CookiesModal", "bottom", true, props.dispatch, props.modals, props.backdrop);
  if (panelApi === null || cookieConsentGiven || isFalseOrMissing(window.OPSEEKER_CONFIG.COOKIES_NOTICE))
    return <React.Fragment />;
  return (
    <RenderModal>
      <TextWrapper>
        <h2>{panelApi.get("TITLE")}</h2>
        {`${panelApi.get("BODY")} `}
        <a
          data-cy="cookies-terms"
          href="/conf/cookies-terms.html"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "underline" }}
        >
          {panelApi.get("LINK_LABEL")}
        </a>
      </TextWrapper>
      <ButtonWrapper>
        <Button
          onClick={() => {
            giveCookieConsent();
            toggleModal(props.dispatch, "CookiesModal", "close");
          }}
          data-cy="button-cookies"
        >
          
          {panelApi.get("OK_BUTTON_LABEL")}
        </Button>
        {props.configEnabled && (
          <Button className="secondary" onClick={() => toggleModal(props.dispatch, "ConfigurePrivacyModal", "open")}>
            Configuración de cookies
          </Button>
        )}
      </ButtonWrapper>
    </RenderModal>
  );
};
